export default __webpack_public_path__ + "static/media/mitareas logo.7a704156.png";